import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import CallSplitOutlinedIcon from "@mui/icons-material/CallSplitOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/Inventory2Outlined";

import DesktopSteps from "./DesktopSteps";
import MobileSteps from "./MobileSteps";

const title = "The Quintet of Destinations";
const description =
  "A complete DAM lifecycle approach to maximize the value of your digital assets.";
const stepsData = [
  {
    number: "01",
    icon: AddOutlinedIcon,
    title: "Create",
    description: "Design, capture, and ingest",
    items: [
      "Content creation workflows",
      "Asset ingestion from multiple sources",
      "Metadata tagging at source",
      "Version control setup",
    ],
  },
  {
    number: "02",
    icon: SettingsIcon,
    title: "Manage",
    description: "Review, automate, and approve",
    items: [
      "Workflow automation",
      "Approval processes",
      "Rights & permissions management",
      "Centralized asset governance",
    ],
  },
  {
    number: "03",
    icon: CallSplitOutlinedIcon,
    title: "Distribute",
    description: "Dynamic delivery and share",
    items: [
      "Multi-channel publishing",
      "CDN / fast delivery",
      "Format transformation",
      "Controlled access sharing",
    ],
  },
  {
    number: "04",
    icon: AutorenewOutlinedIcon,
    title: "Repurpose",
    description: "Search, collect, and reuse",
    items: [
      "Smart search & AI tagging",
      "Content reuse strategies",
      "Campaign adaptation",
      "Reduce duplication",
    ],
  },
  {
    number: "05",
    icon: InventoryOutlinedIcon,
    title: "Archive",
    description: "Expire and preserve",
    items: [
      "Lifecycle policies",
      "Archival storage",
      "Compliance & retention",
      "Easy retrieval",
    ],
  },
];

export default function QuintetDestinations() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        px: {
          xs: "16px",
          customBreakpoint: "24px",
          md: "84px",
        },
        py: {
          xs: "30px",
          customBreakpoint: "48px",
          md: "48px",
        },
        // maxWidth: 1272,
        // mx: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "24px",
              customBreakpoint: "32px",
              md: "40px",
            },
            fontWeight: 700,
            color: "#2A2177",
            mb: 1.25,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: "14px",
              customBreakpoint: "16px",
              md: "18px",
            },
            fontWeight: 400,
            color: "#666666",
            lineHeight: 1.7,
            // mb: 5,
          }}
        >
          {description}
        </Typography>
      </Box>

      {/* Steps and its Data */}
      <Box>
        {isDesktop ? (
          <DesktopSteps stepsData={stepsData} />
        ) : (
          <MobileSteps stepsData={stepsData} />
        )}
      </Box>
    </Box>
  );
}
